import { call, put, takeEvery, all, fork } from "redux-saga/effects";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {
  GET_SHIPMENTCARRIER,
  DELETE_SHIPMENTCARRIER,
  UPDATE_SHIPMENTCARRIER,
  ADD_NEW_SHIPMENTCARRIER,
} from "./actionType";

import {
  getShipmentCarrierSuccess,
  getShipmentCarrierFail,
  deleteShipmentCarrierSuccess,
  deleteShipmentCarrierFail,
  updateShipmentCarrierSuccess,
  updateShipmentCarrierFail,
  addShipmentCarrierSuccess,
  addShipmentCarrierFail,
} from "./action";

//Include Both Helper File with needed carriers
import {
  approveShipmentCarrierApi,
  getShipmentCarrierApi,
  updateShipmentCarrierApi,
  deleteShipmentCarrierApi,
  addNewShipmentCarrierApi
} from "../../helpers/backend_helper";

function* getShipmentCarrier({ payload: shipmentCarrier }) {
  try {
    const response = yield call(getShipmentCarrierApi, shipmentCarrier);
    yield put(getShipmentCarrierSuccess(GET_SHIPMENTCARRIER, response.data));
  } catch (error) {
    yield put(getShipmentCarrierFail(GET_SHIPMENTCARRIER, error));
  }
}

function* onUpdateShipmentCarrier({ payload: shipmentCarrier }) {
  try {
    if (shipmentCarrier.setApprove) {
      const response = yield call(approveShipmentCarrierApi, shipmentCarrier);
      yield put(updateShipmentCarrierSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
    else {
      const response = yield call(updateShipmentCarrierApi, shipmentCarrier);
      yield put(updateShipmentCarrierSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
  } catch (error) {
    yield put(updateShipmentCarrierFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onDeleteShipmentCarrier({ payload: shipmentCarrier }) {
  try {
    const response = yield call(deleteShipmentCarrierApi, shipmentCarrier);
    yield put(deleteShipmentCarrierSuccess({ shipmentCarrier, ...response }));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(deleteShipmentCarrierFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onAddNewShipmentCarrier({ payload: shipmentCarrier }) {
  try {
    const response = yield call(addNewShipmentCarrierApi, shipmentCarrier);
    yield put(addShipmentCarrierSuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(addShipmentCarrierFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }

}

export function* watchGetShipmentCarrier() {
  yield takeEvery(GET_SHIPMENTCARRIER, getShipmentCarrier);
}

export function* watchUpdateShipmentCarrier() {
  yield takeEvery(UPDATE_SHIPMENTCARRIER, onUpdateShipmentCarrier);
}

export function* watchDeleteShipmentCarrier() {
  yield takeEvery(DELETE_SHIPMENTCARRIER, onDeleteShipmentCarrier);
}

export function* watchAddNewShipmentCarrier() {
  yield takeEvery(ADD_NEW_SHIPMENTCARRIER, onAddNewShipmentCarrier);
}

function* shipmentCarrierSaga() {
  yield all([
    fork(watchGetShipmentCarrier),
    fork(watchDeleteShipmentCarrier),
    fork(watchUpdateShipmentCarrier),
    fork(watchAddNewShipmentCarrier)
  ]);
}

export default shipmentCarrierSaga;
